import { Currency } from '../../shared/models/currency.model';
import { Injectable } from '@angular/core';
import currencies from '../../assets/file/currencies.json';

@Injectable()
export class CurrencyHelperService {
    public currencies: object;

    private currenciesArray: Array<any>;

    public static getAlphabetCurrencyCode(numberCurrencyCode) {
        switch (numberCurrencyCode) {
            case '566':
                return 'NGN';
            case '840':
                return 'USD';
            case '978':
                return 'EUR';
            case '826':
                return 'GBP';
            case '036':
                return 'AUD';
            default:
                return numberCurrencyCode;
        }
    }

    constructor() {
        this.loadCurrencies();
    }

    public loadCurrencies() {
        this.currencies = currencies;
        this.currenciesArray = Object.values(currencies);
    }

    public getCurrentObject(iso: string): Currency {
        if (!iso) {
            return undefined;
        }
        if (iso.length > 1) {
            return this.currenciesArray.find((c) => c.iso.code === iso || c.iso.number === iso);
        } else {
            return this.currenciesArray.find((c) => c.units.major.symbol === iso || c.units.minor.symbol === iso);
        }
    }

    public resolveCurrencyMajorMinor(amount: number, currency: string) {
        const curr: Currency = this.getCurrentObject(currency);
        if (curr) {
            return amount * curr.units.minor.majorValue;
        }
        return amount;
    }
}
